module.exports = __webpack_public_path__ + "graphics/button-roblox.ckh.e30e5bca36ca67e1623781e7f83745fb.svg";